import Axios from "../utils/request";
import _this from "../main.js";
import lrz from "lrz";

// 上传前压缩
export const lrzUploadImage = (file, echoField, callback,application_id) => {
  console.log("lrzUploadImage = (file, echoField, callback)",file, echoField, callback);
  let len = 1 * (1024 * 1024);
  // 大于5M的图片压缩
  if (file.size > len) {
    lrz(file, {
      // with: 50, // 图片最大的宽度。默认为原图的宽度
      // height: 50, // 图片最大的高度，默认为原图的高度
      quality: 0.1, // 图片压缩质量，取值0-1，默认为0.7
      // filedName: 'file', // 后端接收的字段名，默认为 'file'
    })
      .then((rst) => {
        // 处理成功会执行
        uploadImage(new File([rst.file], rst.origin.name), echoField, callback,application_id);
      })
      .catch(function(err) {
        // 处理失败会执行
        console.log("上传图片lrzUploadImage err", err);
      });
  } else {
    uploadImage(new File([file], file.name), echoField, callback,application_id);
  }
};

// 全局上传
export const uploadImage = (file, echoField, callback,application_id) => {
  let reqUrl = "";
  let isShowUnloading = false;
  let formData = new FormData();
  formData.append("file", file);
  if (echoField == "imgIdCardPositive") {
    reqUrl = "/tw/user/userMediaSingle";
    formData.append("file_type", 1);
  } else if (echoField == "imgIdCardBack") {
    reqUrl = "/tw/user/userMediaSingle";
    formData.append("file_type", 2);
  } else if (echoField == "imgIdCardHold") {
    reqUrl = "/tw/user/userMediaSingle";
    formData.append("file_type", 3);
  } else if (echoField == "imgBankSavebook") {
    reqUrl = "/tw/user/userMediaSingle";
    formData.append("file_type", 177);
  } else if (echoField == "personPhoto") {
    reqUrl = "/tw/user/userMediaSingle";
    formData.append("file_type", 20);
  } else if (echoField == "facePhoto1") {
    isShowUnloading = true;
    reqUrl = "/tw/user/userMediaSingle";
    formData.append("file_type", 30);
  } else if (echoField == "facePhoto2") {
    isShowUnloading = true;
    reqUrl = "/tw/user/userMediaSingle";
    formData.append("file_type", 40);
  } else if (echoField == "facePhoto3") {
    isShowUnloading = true;
    reqUrl = "/tw/user/userMediaSingle";
    formData.append("file_type", 50);
  } else if (echoField == "uploadContract") {
    // isShowUnloading = true;
    reqUrl = "/tw/user/uploadContract";
    formData.append("file_type", 149);
    formData.append("application_id", application_id);
  }

  const userResult = _this.$store.state.user.userInfo;
  if (userResult?.user_id) {
    formData.append("user_id", userResult.user_id);
  }
  if (userResult?.imei) {
    formData.append("imei", userResult.imei);
  }
  if (userResult?.loginStaticKey) {
    formData.append("loginStaticKey", userResult.loginStaticKey);
  }
  if (userResult?.version) {
    formData.append("app_version", userResult.version);
    formData.append("appversion", userResult.version);
    formData.append("version", userResult.version);
  }
  formData.append("timestamp", Date.now());
  formData.append("sign", "0f656af82eb1da33221a06d1171db265");

  if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
    formData.append("pkg_name", "com.loan.yizhunh5ios");
	} else if (navigator.userAgent.match(/android/i)) {
    formData.append("pkg_name", "com.loan.yizhunh5");
	}

  formData.append("channel", localStorage.getItem("channel"));
  Axios({
    url: reqUrl,
    method: "post",
    data: formData,
    isShowUnloading,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  })
    .then((res) => {
      console.log("res", res);
      if (res.code == 200) {
        let url = res.result;
        callback && callback(true, url);
        console.log("callback && callback(true, url)", url);

        let config = JSON.parse(localStorage.getItem("config"));
        if (echoField == "imgIdCardPositive" && config.ocr_switch) {
          reqUrl = "/v2/ocr";
          Axios({
            url: reqUrl,
            method: "post",
            data: {
              fileType: "1",
            },
            isShowUnloading,
          })
            .then((res) => {
              console.log("res", res);
              if (res.code == 200) {
                let url = res.result;
                callback && callback(true, url);
              }
            })
        }
      } else {
        // 上传失败
        callback && callback(false);
      }
    })
    .catch(() => {
      callback && callback(false);
    });
};

// 上传base64
export const uploadBase64Image = (data) =>
  Axios({
    url: "/app/uploadBase64Image",
    method: "post",
    data,
  });

// 上传前压缩
export const lrzUploadRepayVouch = (data, callback) => {
  console.log("lrzUploadRepayVouch = (data)", data);
  let len = 2 * (1024 * 1024);
  // 大于5M的图片压缩
  if (data.file.size > len) {
    lrz(data.file, {
      // with: 50, // 图片最大的宽度。默认为原图的宽度
      // height: 50, // 图片最大的高度，默认为原图的高度
      quality: 0.1, // 图片压缩质量，取值0-1，默认为0.7
      // filedName: 'file', // 后端接收的字段名，默认为 'file'
    })
        .then((rst) => {
          console.log(
              "lrzUploadRepayVouch压缩",
              new File([rst.file], rst.origin.name).size
          );
          // 处理成功会执行
          data.file = new File([rst.file], rst.origin.name);
          repayVouch(data, callback);
        })
        .catch(function(err) {
          // 处理失败会执行
          console.log("上传图片lrzUploadRepayVouch err", err);
        });
  } else {
    data.file = new File([data.file], data.file.name);
    repayVouch(data, callback);
  }
};
// 上传还款凭证
export const repayVouch = (data, callback) => {
  console.log("repayVouch", data.file.size);
  let formData = new FormData();
  formData.append("file", data.file);
  const userResult = _this.$store.state.user.userInfo;
  if (userResult?.user_id) {
    formData.append("user_id", userResult.user_id);
  }
  if (userResult?.imei) {
    formData.append("imei", userResult.imei);
  }
  if (userResult?.loginStaticKey) {
    formData.append("loginStaticKey", userResult.loginStaticKey);
  }
  if (userResult?.version) {
    formData.append("app_version", userResult.version);
    formData.append("appversion", userResult.version);
    formData.append("version", userResult.version);
  }
  formData.append("timestamp", Date.now());
  formData.append("sign", "0f656af82eb1da33221a06d1171db265");

  formData.append("amount", data.amount);
  formData.append("application_id", data.application_id);
  formData.append("bankCardNo", data.bankCardNo);
  formData.append("cardNo", data.cardNo);
  formData.append("vaType", data.vaType);

  if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
    formData.append("pkg_name", "com.loan.yizhunh5ios");
  } else if (navigator.userAgent.match(/android/i)) {
    formData.append("pkg_name", "com.loan.yizhunh5");
  }

  formData.append("channel", localStorage.getItem("channel"));
  Axios({
    url: "/loan/repay/vouch",
    method: "post",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  })
      .then((res) => {
        if (res.code == 200) {
          callback && callback(true);
        }
      })
      .catch(() => {
        callback && callback(false);
      });
};
